/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/SystemBlocks.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for System Blocks
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Sunday, September 23, 2018 - 3:06 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/23/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    SYSTEMBLOCK_LIST_CONTAINER_LOADED,
    SYSTEMBLOCK_LIST_CONTAINER_UNLOADED,
    SYSTEMBLOCK_LIST_TABLE_LOADED,
    SYSTEMBLOCK_LIST_TABLE_UNLOADED,
    SYSTEMBLOCK_LIST_CHANGE_COMPANY,
    SYSTEMBLOCK_LIST_CHANGE_LISTGROUP,
    SYSTEMBLOCK_SELECT_ROW,
    SYSTEMBLOCK_ADD,
    SYSTEMBLOCK_EDIT,
    SYSTEMBLOCK_DELETE,
    SYSTEMBLOCK_DELETE_DISABLE,
    SYSTEMBLOCK_OPEN_WARNING,
    SYSTEMBLOCK_CLOSE_WARNING,
    SYSTEMBLOCK_EDIT_CONTAINER_LOADED,
    SYSTEMBLOCK_EDIT_CONTAINER_UNLOADED,
    SYSTEMBLOCK_EDIT_FORM_LOADED,
    SYSTEMBLOCK_EDIT_FORM_UNLOADED,
    SYSTEMBLOCK_EDIT_LOAD_LISTGROUPS,
    SYSTEMBLOCK_EDIT_CHANGE_COMPANY,
    SYSTEMBLOCK_EDIT_DATA_LOAD,
    SYSTEMBLOCK_SET_COMPANY_SELECT,
    SYSTEMBLOCK_SET_LISTGROUP_SELECT,
    SYSTEMBLOCK_EDIT_CONTAINER_SUBMIT,
    SYSTEMBLOCK_EDIT_CONTAINER_CANCEL,
    SYSTEMBLOCK_TEST
} from '../constants/actionTypeSystemBlocks';

const defaultState = {
    refreshList: false,
    systemBlocks: [],
    companies: [],
    listgroups: [],
    companyOptions: [],
    listGroupOptions: [],
    listGroupDisabled: false,
    companyid_f: 0,
    listgroupid_f: 0,
    danger: false,
    systemlistid: 0,
    listgroupid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case SYSTEMBLOCK_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlists: action.payload[0] ? action.payload[0].records : [],
                companies: action.payload[1] ? action.payload[1].companies : [],
                listgroups: []
            }
        case SYSTEMBLOCK_LIST_CHANGE_COMPANY:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlists: action.payload[0] ? action.payload[0].records : [],
                listgroups: action.payload[1] ? action.payload[1].records : [],
                companyid_f: action.companyid,
                listgroupid_f: 0
            }
        case SYSTEMBLOCK_LIST_CHANGE_LISTGROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                systemlists: action.payload ? action.payload.records : [],
                listgroupid_f: action.listgroupid
            }
        case SYSTEMBLOCK_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case SYSTEMBLOCK_SELECT_ROW:
            return {
                ...state,
                systemlistid: action.id
            }
        case SYSTEMBLOCK_ADD:
            return {
                ...state
            }
        case SYSTEMBLOCK_EDIT:
            return {
                ...state,
                systemlistid: action.id
            }
        case SYSTEMBLOCK_DELETE:
            return {
                ...state,
                systemlistid: null
            }
        case SYSTEMBLOCK_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case SYSTEMBLOCK_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case SYSTEMBLOCK_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case SYSTEMBLOCK_SET_COMPANY_SELECT:
            return {
                ...state,
                companyOptions: action.payload ? action.payload : []
            }
        case SYSTEMBLOCK_SET_LISTGROUP_SELECT:
            return {
                ...state,
                listGroupOptions: action.payload ? action.payload : [],
                listGroupDisabled: action.listGroupDisabled
            }
        case SYSTEMBLOCK_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                companies: action.payload[1] ? action.payload[1].companies : [],
                listgroups: action.payload[2] ? action.payload[2].records : [],
                systemlistid: action.payload[0] ? action.payload[0].systemlistid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                listgroupid: action.payload[0] ? action.payload[0].listgroupid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case SYSTEMBLOCK_EDIT_DATA_LOAD:
            return {
                ...state,
                systemlistid: action.payload ? action.payload.systemlistid : 0,
                companyid: action.payload ? action.payload.companyid : 0,
                listgroupid: action.payload ? action.payload.listgroupid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case SYSTEMBLOCK_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case SYSTEMBLOCK_EDIT_LOAD_LISTGROUPS:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                listgroups: action.payload ? action.payload.records : []
            }
        case SYSTEMBLOCK_EDIT_CHANGE_COMPANY:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                listgroups: action.payload ? action.payload.records : []
            }
        case SYSTEMBLOCK_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case SYSTEMBLOCK_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case SYSTEMBLOCK_TEST:
            console.log('SYSTEMBLOCK_TEST');
            console.log(action.payload);
            return {
                ...state,
                fieldJSON: action.payload ? action.payload.fields : []
            }
        case SYSTEMBLOCK_LIST_CONTAINER_UNLOADED:
        case SYSTEMBLOCK_LIST_TABLE_UNLOADED:
        case SYSTEMBLOCK_EDIT_CONTAINER_UNLOADED:
        case SYSTEMBLOCK_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/SystemBlocks.js